import testApi from './testApi'
import CrmUsers from './crmUsers'
import AssetApi from './assets'
import Configuration from './configuration'
import ActivitiesApi from './activities'
import TariffsBillings from './tariffsBilling'
import SynamicLoad from './synamicLoad'
export default { testApi, AssetApi, CrmUsers, Configuration, ActivitiesApi, TariffsBillings, SynamicLoad }
